import { SyntheticEvent, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import submit from '@r1-frontend/unified-address-form/actions/submit';
import { TSubmitButtonResult } from '@r1-frontend/unified-address-form/containers/SubmitButton';
import { Ctx as UnifiedAddressFormContext } from '@r1-frontend/unified-address-form/Ctx';
import * as unifiedAddressFormHooks from '@r1-frontend/unified-address-form/hooks';
import getSubmitButtonProps from '@r1-frontend/unified-address-form/selectors/getSubmitButtonProps';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { TNextButtonHook } from '~/src/features/full-buy/containers/GoToNextStepButton/types';
import { setAddress, updateConnectionCostForSelectedTariff } from '~/src/features/full-buy/store/actions';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import getAddressCheckingResult from '~/src/features/full-buy/store/selectors/getAddressCheckingResult';

const useUnifiedAddressFormNextButton = (): TNextButtonHook => {
    const analytics = useAnalytics();
    const dispatch = useDispatch();

    const checkingResult = useSelector(getAddressCheckingResult);

    const { analytics: unifiedAddressAnalytics } = useContext(UnifiedAddressFormContext);
    const uafDispatch = unifiedAddressFormHooks.useCtxDispatch();
    const submitButtonProps = unifiedAddressFormHooks.useCtxSelector(getSubmitButtonProps);

    const onAddressConfirmedCallback = (result: TSubmitButtonResult) => {
        dispatch(setAddress({
            address: result.address,
            isConnectionAvailable: result.isConnectionAvailable,
            isTariffAvailable: Boolean(result.isTariffAvailableForActivation),
            // @ts-ignore
            checkingResult: result,
        }));

        if (result.address.connectionCost) {
            dispatch(updateConnectionCostForSelectedTariff(result.address.connectionCost));
        }
    };

    if (!checkingResult.isChecked) {
        return {
            disabled: submitButtonProps.disabled,
            onClick: (e: SyntheticEvent) => {
                e.stopPropagation();
                uafDispatch(submit(onAddressConfirmedCallback, unifiedAddressAnalytics));
            },
            children: 'Проверить адрес',

        };
    } else {
        return {
            doNotDisplay: !checkingResult.isTariffAvailable,
            disabled: !(checkingResult.isTariffAvailable && checkingResult.isConnectionAvailable),
            onClick: (e: SyntheticEvent) => {
                e.stopPropagation();
                analytics.address.continueClicked();
                dispatch(goToNextStep());
            },
            children: 'Продолжить',
        };
    }
};

export default useUnifiedAddressFormNextButton;
